import { map, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'

import { Order } from '../../../core/models/order'
import { Address } from '../../../core/models/address'

import * as checkout from '../../actions/checkout'
import * as fromCheckout from '../../reducers'
import * as fromAuth from '../../../auth/reducers'
import * as fromBase from '../../../base/reducers';

import { ContainerBase } from '../../../core/base/container-base'
import { PageRoutingService } from '../../../core/services/page-routing.service';
import { Setting } from '../../../core/models/setting';
import { ExtraCost } from '../../../cart/models/cart-models';

@Component({
  selector: 'app-summary-container',
  templateUrl: './template.html'
})
export class SummaryContainer extends ContainerBase implements OnDestroy {
  order$: Observable<Order>
  addresses$: Observable<Address[]>
  quantityPicker$: Observable<string>
  checkoutPageSettings$: Observable<Setting>
  extraCosts$: Observable<ExtraCost[]>

  constructor(
    private store: Store<fromCheckout.State>,
    private pageRoutingSvc: PageRoutingService,
    private route: ActivatedRoute
  ) {
    super()
    this.pageRoutingSvc.breadcrumbsStatus = false

    route.params.pipe(
      map(params => new checkout.OrderSummary(params.id)))
      .subscribe(store)

    this.order$ = this.store.pipe(
      select(fromCheckout.getSummaryOrder),
      takeUntil(this.destroyed$)
    )
    this.addresses$ = this.store.pipe(
      select(fromAuth.getAddresses),
      takeUntil(this.destroyed$)
    )
    this.quantityPicker$ = this.store
      .pipe(
        select(fromBase.getQuantityPicker),
        takeUntil(this.destroyed$)
      )
    this.checkoutPageSettings$ = store
      .pipe(
        select(fromBase.getCheckoutPageSettings),
        takeUntil(this.destroyed$)
      )
    this.extraCosts$ = store
      .pipe(
        select(fromCheckout.getSummaryOrderExtraCosts),
        takeUntil(this.destroyed$)
      )
  }

  ngOnDestroy() {
    this.pageRoutingSvc.breadcrumbsStatus = true
  }
}
